export default __webpack_public_path__ + "static/Empty-04d94837e9aa1cca64fd27a1f57befe1.png";